import { gql } from '@apollo/client';

const query = gql`
  query localsearchCMSArticles {
    localsearchCMSArticles {
      results {
        article {
          articleTitle
          urlSlug
          featureImageUrl
          wordCount
        }
      }
    }
  }
`;

module.exports = query;
